import FadeInSection, { FadeInType } from "./wrappers/FadeInSection";
import { paths } from "../globals";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import { useState, useEffect } from "react";
import { useNotification } from "../components/individuals/NotificationProvider";

const CustomForm = ({
  status,
  message,
  onValidated,
  setErrorState,
  setSuccessState,
}) => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (status === "sending") {
      return;
    }
    if (email === "test@gmail.com") {
      setErrorState(true);
      setSuccessState(false);
      setIsLoading(false);
      return;
    }
    email &&
      email.indexOf("@") > -1 &&
      onValidated({
        EMAIL: email,
      });
  };

  useEffect(() => {
    if (status === "error") {
      setErrorState(true);
      setSuccessState(false);
      setIsLoading(false);
    } else if (status === "success") {
      setSuccessState(true);
      setErrorState(false);
      setIsLoading(false);
      setEmail("");
    }
  }, [status, setErrorState, setSuccessState]);

  return (
    <form className="relative" onSubmit={submit}>
      <input
        required
        type="email"
        name="email"
        id="email"
        placeholder="Email address"
        onChange={(e) => setEmail(e.target.value)}
        value={email}
        className="placeholder-opacity-40 text-dark-text focus:border-primary w-full rounded-sm border py-3 pr-12 pl-5 text-base outline-hidden dark:border-transparent dark:bg-[#2C3443]"
      />
      {isLoading ? <div className="absolute top-0 right-0 flex h-full w-12 items-center justify-center">
          <svg
            className="size-5 animate-spin text-dark-text"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div> : (
        <button className="text-dark-text absolute top-0 right-0 flex h-full w-12 items-center justify-center border-l dark:border-[#1F2633] hover:text-primary cursor-pointer">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            className="fill-current"
          >
            <path d="M3.1175 1.17367L18.5025 9.63533C18.5678 9.6713 18.6223 9.72414 18.6602 9.78834C18.6982 9.85255 18.7182 9.92576 18.7182 10.0003C18.7182 10.0749 18.6982 10.1481 18.6602 10.2123C18.6223 10.2765 18.5678 10.3294 18.5025 10.3653L3.1175 18.827C3.05406 18.8619 2.98262 18.8797 2.91023 18.8785C2.83783 18.8774 2.76698 18.8575 2.70465 18.8206C2.64232 18.7838 2.59066 18.7313 2.55478 18.6684C2.51889 18.6056 2.50001 18.5344 2.5 18.462V1.53867C2.50001 1.46626 2.51889 1.39511 2.55478 1.33222C2.59066 1.26934 2.64232 1.21689 2.70465 1.18005C2.76698 1.1432 2.83783 1.12324 2.91023 1.12212C2.98262 1.121 3.05406 1.13877 3.1175 1.17367ZM4.16667 10.8337V16.3478L15.7083 10.0003L4.16667 3.65283V9.167H8.33333V10.8337H4.16667Z"></path>
          </svg>
        </button>
      )}
    </form>
  );
};

export default function Footer() {
  const [successState, setSuccessState] = useState(false);

  const [errorState, setErrorState] = useState(false);
  const { showNotification } = useNotification();

  useEffect(() => {
    if (successState) {
      window.scrollTo({top: 0, behavior: "smooth" });
      showNotification("Thanks for subscribing to our newsletter!", "success");
      setSuccessState(false);
    }
  }
  , [successState, showNotification]);
  return (
    <footer
      className={` pt-14 sm:pt-20 lg:pt-[130px] transition-opacity duration-500`}
      id="footer"
    >
      <div className="px-4 mx-auto w-5/6 xl:w-3/5">
        <FadeInSection distance={FadeInType.FADEONLY}>
          <div className="-mx-4 flex flex-wrap">
            <div className="w-full px-4 sm:w-1/2 md:w-6/12 lg:w-4/12 xl:w-3/12">
              <div className="mb-20 max-w-[330px]">
                <a href="/" className="mb-6 inline-block">
                  <img
                    src="/assets/logo.png"
                    alt="logo"
                    className="hidden h-[50px] dark:block"
                  />
                  <img
                    src="/assets/logo.png"
                    alt="logo"
                    className="h-[50px] dark:hidden"
                  />
                </a>

                <p className="text-dark-text mb-10 text-base">
                  STEM Enrichment of New Jersey
                </p>
                <div className="flex items-center space-x-5">
                  {/* <a
                    href="https://facebook.com/61573552978398"
                    name="social-link"
                    aria-label="social-link"
                    className="text-dark-text hover:text-primary dark:hover:text-white"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      className="fill-current"
                    >
                      <path d="M14 13.5H16.5L17.5 9.5H14V7.5C14 6.47 14 5.5 16 5.5H17.5V2.14C17.174 2.097 15.943 2 14.643 2C11.928 2 10 3.657 10 6.7V9.5H7V13.5H10V22H14V13.5Z"></path>
                    </svg>
                  </a> */}
                  <a
                    href="https://instagram.com/stemenj_north"
                    name="social-link"
                    aria-label="social-link"
                    className="text-dark-text hover:text-primary dark:hover:text-white"
                  >
                    <svg
                      width="24"
                      height="24"
                      aria-hidden="true"
                      className="fill-current"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </a>
                  <a
                    href="https://instagram.com/stemenj_south"
                    name="social-link"
                    aria-label="social-link"
                    className="text-dark-text hover:text-primary dark:hover:text-white"
                  >
                    <svg
                      width="24"
                      height="24"
                      aria-hidden="true"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </a>
                </div>
              </div>
            </div>

            <div className="w-1/2 px-4 md:w-3/12 lg:w-3/12 xl:w-2/12">
              <div className="mb-20">
                <h3 className="font-main text-dark mb-9 text-2xl font-medium dark:text-white">
                  Pages
                </h3>

                <ul className="space-y-4">
                  {paths.map((item, index) => (
                    <li key={index}>
                      <a
                        href={item.path}
                        className={
                          "font-main text-dark-text hover:text-primary text-base dark:hover:text-white"
                        }
                      >
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* <div className="w-1/2 px-4 md:w-3/12 lg:w-3/12 xl:w-2/12">
            <div className="mb-20">
              <h3 className="font-main text-dark mb-9 text-2xl font-medium dark:text-white">
                Support
              </h3>

              <ul className="space-y-4">
                <li>
                  <a
                    href=""
                    className="font-main text-dark-text hover:text-primary text-base dark:hover:text-white"
                  >
                    Company
                  </a>
                </li>
                <li>
                  <a
                    href=""
                    className="font-main text-dark-text hover:text-primary text-base dark:hover:text-white"
                  >
                    Press media
                  </a>
                </li>
                <li>
                  <a
                    href=""
                    className="font-main text-dark-text hover:text-primary text-base dark:hover:text-white"
                  >
                    Our Blog
                  </a>
                </li>
                <li>
                  <a
                    href=""
                    className="font-main text-dark-text hover:text-primary text-base dark:hover:text-white"
                  >
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>
          </div> */}
            {/* if this is ever uncommented, you need to redistribute the space in the footer to make it add up to 12 parts again */}

            <div className="w-full px-4 sm:w-1/2 md:w-6/12 lg:w-4/12 xl:w-3/12">
              <div className="mb-20">
                <h3 className="font-main text-dark mb-9 text-2xl font-medium dark:text-white">
                  Get in touch
                </h3>

                <div className="space-y-7">
                  <div>
                    <p className="font-main text-dark-text text-base">
                      By Phone
                    </p>
                    <a
                      href="tel:+1 (973) 932-4185"
                      className="font-main text-dark hover:text-primary dark:hover:text-primary text-base dark:text-white"
                    >
                      +1 (973) 932-4185
                    </a>
                  </div>
                  <div>
                    <p className="font-main text-dark-text text-base">
                      By Email
                    </p>
                    <a
                      href="mailto:stemenj1@gmail.com"
                      className="font-main text-dark hover:text-primary dark:hover:text-primary text-base dark:text-white"
                    >
                      stemenj1@gmail.com
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full px-4 sm:w-1/2 md:w-6/12 lg:w-6/12 xl:w-4/12">
              <div className="mb-20">
                <h3 className="font-main text-dark mb-9 text-2xl font-medium dark:text-white">
                  Newsletter
                </h3>
                <p className="font-main text-dark-text mb-6 text-base">
                  Subscribe to receive future updates
                </p>
                <MailchimpSubscribe
                  url={
                    "https://stemepa.us12.list-manage.com/subscribe/post?u=c7e5759549b41657ed7876a36&amp;id=bc64426544&amp;f_id=0099c2e1f0&c="
                  }
                  render={({ subscribe, status, message }) => (
                    <CustomForm
                      status={status}
                      message={message}
                      onValidated={(formData) => subscribe(formData)}
                      setSuccessState={setSuccessState}
                      setErrorState={setErrorState}
                    />
                  )}
                />
                <p className="font-main text-red-600 mt-2 text-xs">
                  {errorState && "Please enter a valid email address."}
                </p>
                <p className="font-main text-green-400 mt-2 text-xs">
                  {successState && "Success!"}
                </p>
              </div>
            </div>
          </div>

          <div className="md:border-t dark:border-[#2E333D]">
            <div className="-mx-4 flex flex-wrap py-5 md:py-7">
              <div className="w-full px-4 md:w-1/4 lg:w-1/6">
                <div className="mb-5 flex items-center justify-center space-x-5 border-b pb-5 md:mb-0 md:justify-start md:border-0 md:pb-0 dark:border-[#2E333D]">
                  <a
                    href="/privacy"
                    className="font-main text-dark-text hover:text-primary text-base"
                  >
                    Privacy Policy
                  </a>
                </div>
              </div>
              <div className="w-full px-4 md:w-1/4 lg:w-1/6">
                <div className="mb-5 flex items-center justify-center space-x-5 border-b pb-5 md:mb-0 md:justify-start md:border-0 md:pb-0 dark:border-[#2E333D]">
                  <a
                    href="/terms"
                    className="font-main text-dark-text hover:text-primary text-base"
                  >
                    Terms of Service
                  </a>
                </div>
              </div>
              <div className="w-full px-4 md:w-1/2 lg:w-2/3">
                <div>
                  <p className="font-main text-dark-text text-center text-base lg:text-right">
                    © 2025 STEM Enrichment of New Jersey, a suborganization of
                    STEMEPA. <br />
                    All rights reserved. 501(c)3 Organization
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeInSection>
      </div>
    </footer>
  );
}
